let arrival_data2 = [
    {
        id : 4,
        imgurl : '/img/newarrival/section3_women5.jpg',
        brand : 'RENEJ',
        title : 'Shirring Golgi V-Cardigan',
        persent : '10%',
        price : '198,000',
        saleprice : '151,470',
    },
    {
        id : 5,
        imgurl : '/img/newarrival/section3_women6.jpg',
        brand : 'A.T.CORNER',
        title : '브이넥 볼륨 소매 블라우스 블랙',
        persent : '15%',
        price : '139,000',
        saleprice : '118,150',
    },
    {
        id : 6,
        imgurl : '/img/newarrival/section3_women7.jpg',
        brand : 'JILLSTUART NEW YORK WOMEN',
        title : '블랙 단색 폴리혼방 플레어스커트',
        persent : '7%',
        price : '399,000',
        saleprice : '371,070',
    },
    {
        id : 7,
        imgurl : '/img/newarrival/section3_women8.jpg',
        brand : 'HAZZYS LADIES',
        title : '블랙 스티치장식 스커트',
        persent : '33%',
        price : '269,000',
        saleprice : '180,120',
    },
]

export default arrival_data2